module.exports = __webpack_public_path__ + "media/images/ticket/to_next_ov-0426c849dcf6286de35e21e44df4855d.png";